function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1920(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 14.67,
    height: 2.48,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.41333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 1.24
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.48,
    width: 14.67,
    height: 8.88,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 6.92
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.36,
    width: 14.67,
    height: 24.81,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 23.765
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36.17,
    width: 14.67,
    height: 30.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.83375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 51.635000000000005
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 67.1,
    width: 14.67,
    height: 33.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 83.945
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100.79,
    width: 14.67,
    height: 35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 118.29
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.79,
    width: 14.67,
    height: 55.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 163.43
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.07,
    width: 14.67,
    height: 56.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.934
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 219.115
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 247.16,
    width: 14.67,
    height: 61.4,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 277.86
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 308.56,
    width: 14.67,
    height: 73.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 345.525
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 382.49,
    width: 14.67,
    height: 74.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 419.735
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 456.98,
    width: 14.67,
    height: 76.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.83375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 495.27000000000004
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 533.56,
    width: 14.67,
    height: 81.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 574.505
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 615.46,
    width: 14.67,
    height: 84.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.335,
    y: 657.73
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 0,
    width: 31.2,
    height: 42.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.466666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.27,
    y: 21.145
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.87,
    y: 0,
    width: 32.5,
    height: 42.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.12,
    y: 21.145
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.37,
    y: 0,
    width: 32.97,
    height: 42.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.855,
    y: 21.145
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.34,
    y: 0,
    width: 34.93,
    height: 42.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.7325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.805,
    y: 21.145
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.27,
    y: 0,
    width: 36.64,
    height: 42.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.328
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.59,
    y: 21.145
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.91,
    y: 0,
    width: 37.1,
    height: 42.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.46,
    y: 21.145
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.01,
    y: 0,
    width: 38.82,
    height: 42.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.42,
    y: 21.145
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.83,
    y: 0,
    width: 39.38,
    height: 42.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5633333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.52,
    y: 21.145
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.21,
    y: 0,
    width: 41.68,
    height: 42.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.946666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.04999999999995,
    y: 21.145
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.89,
    y: 0,
    width: 48.89,
    height: 42.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.048333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.335,
    y: 21.145
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.78,
    y: 0,
    width: 57.77,
    height: 42.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.458
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.66499999999996,
    y: 21.145
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.55,
    y: 0,
    width: 59.46,
    height: 42.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.28625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.28000000000003,
    y: 21.145
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.01,
    y: 0,
    width: 59.76,
    height: 42.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.048333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.89,
    y: 21.145
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.77,
    y: 0,
    width: 66.87,
    height: 42.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.5725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.2049999999999,
    y: 21.145
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.64,
    y: 0,
    width: 67.36,
    height: 42.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.048333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.3199999999999,
    y: 21.145
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 42.29,
    width: 66.76,
    height: 48.72,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 66.65
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 91.01,
    width: 66.76,
    height: 52.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4859999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 117.155
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 143.29,
    width: 66.76,
    height: 52.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 169.52499999999998
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 195.76,
    width: 66.76,
    height: 53.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.644285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 222.515
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 249.28,
    width: 66.76,
    height: 55.27,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.90875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 276.915
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 304.55,
    width: 66.76,
    height: 56.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 332.865
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 361.18,
    width: 66.76,
    height: 60.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 391.555
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 421.93,
    width: 66.76,
    height: 62,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 452.93
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 483.93,
    width: 66.76,
    height: 64.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.803999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 515.94
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 547.95,
    width: 66.76,
    height: 72.62,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 584.26
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 620.56,
    width: 66.76,
    height: 79.44,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.417777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.050000000000004,
    y: 660.28
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 42.29,
    width: 71.49,
    height: 74.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.499230769230769
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.16499999999999,
    y: 79.785
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.91,
    y: 42.29,
    width: 75.89,
    height: 74.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.498333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.855,
    y: 79.785
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.8,
    y: 42.29,
    width: 79.06,
    height: 74.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.499
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.33000000000004,
    y: 79.785
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.86,
    y: 42.29,
    width: 90.79,
    height: 74.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.33222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.255,
    y: 79.785
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.65,
    y: 42.29,
    width: 98.16,
    height: 74.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2491666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.72999999999996,
    y: 79.785
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496.81,
    y: 42.29,
    width: 99.97,
    height: 74.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.7475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.795,
    y: 79.785
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 596.78,
    y: 42.29,
    width: 103.22,
    height: 74.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.498333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.39,
    y: 79.785
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 117.28,
    width: 110.04,
    height: 73.17,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.44,
    y: 153.865
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 190.45,
    width: 110.04,
    height: 84.4,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.066666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.44,
    y: 232.64999999999998
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 274.85,
    width: 110.04,
    height: 92.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.446363636363635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.44,
    y: 321.305
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 367.77,
    width: 110.04,
    height: 93.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.712142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.44,
    y: 414.755
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 461.73,
    width: 110.04,
    height: 113.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.004000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.44,
    y: 518.57
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.42,
    y: 575.41,
    width: 110.04,
    height: 124.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.44,
    y: 637.7049999999999
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.46,
    y: 117.28,
    width: 88.18,
    height: 169.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.016363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.55,
    y: 201.845
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.64,
    y: 117.28,
    width: 95.4,
    height: 169.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.600000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.34,
    y: 201.845
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.04,
    y: 117.28,
    width: 324.96,
    height: 169.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.16142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.52,
    y: 201.845
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.46,
    y: 286.41,
    width: 185.05,
    height: 413.59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.234615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.985,
    y: 493.20500000000004
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.51,
    y: 286.41,
    width: 323.49,
    height: 413.59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.40818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.255,
    y: 493.20500000000004
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1920);
export default __webpack_public_path__ + "static/media/1920.baa9cb373304d413e2c1d29a5dba66c3.svg";
export { ForwardRef as ReactComponent };